<app-admin-page-section titleT="admin.sharepoint-templates.title">
    <div class="admin-action-item-list">

        <app-admin-action-item titleT="admin.sharepoint-templates.customer-space-template" [titleHint]="'admin.sharepoint-templates.last-refreshed'
          | translate
          : {
          lastUpdate: latestTemplateUpdates()?.latestCustomerSpaceTemplateActualisation | date: 'dd.MM.yyyy HH:mm:ss'
          }">

            <app-button-indicator svgIcon="reload" [isPending]="extractPending()"
                areaLabelT="admin.sharepoint-templates.refresh-now" toolTipT="admin.sharepoint-templates.refresh-now"
                (clicked)="extractCustomerSpaceTemplate()" />
        </app-admin-action-item>

        <app-admin-action-item titleT="admin.sharepoint-templates.project-template" [titleHint]="'admin.sharepoint-templates.last-refreshed'
          | translate: { lastUpdate: latestTemplateUpdates()?.latestProjectTemplateActualisation | date: 'dd.MM.yyyy
          HH:mm:ss' }">

            <app-button-indicator svgIcon="reload" [isPending]="extractPending()"
                areaLabelT="admin.sharepoint-templates.refresh-now" toolTipT="admin.sharepoint-templates.refresh-now"
                (clicked)="extractProjectTemplate()" />

        </app-admin-action-item>



    </div>
</app-admin-page-section>